import { useId, useState } from 'react';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { KC_COLORS } from '../theme';

/** Remove leading "1. " / "2) " style numbering from FAQ questions. */
function cleanFaqQuestion(question = '') {
  return String(question).replace(/^\s*\d+[.)]\s+/, '').trim();
}

export function FaqAccordion({ faqs = [], idPrefix = 'faq' }) {
  const [openIndex, setOpenIndex] = useState(null);
  const reactId = useId();

  if (!faqs.length) return null;

  return (
    <div className="kc-faq-list flex flex-col gap-2.5" id={idPrefix}>
      {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        const panelId = `${idPrefix}-${reactId}-panel-${index}`;
        const buttonId = `${idPrefix}-${reactId}-button-${index}`;
        const question = cleanFaqQuestion(faq.question);

        return (
          <div
            key={`${question}-${index}`}
            className={`kc-faq-item relative overflow-hidden rounded-xl border bg-white ${
              isOpen ? 'kc-faq-item--open' : ''
            }`}
            style={{ borderColor: isOpen ? KC_COLORS.teal : KC_COLORS.border }}
          >
            <span className="kc-faq-accent" aria-hidden="true" />

            <button
              type="button"
              id={buttonId}
              className="kc-faq-trigger relative w-full text-left flex items-start gap-3.5 md:gap-4 px-4 md:px-5 py-3.5 md:py-4 cursor-pointer"
              aria-expanded={isOpen}
              aria-controls={panelId}
              onClick={() =>
                setOpenIndex((current) => (current === index ? null : index))
              }
            >
              <span className="flex-1 min-w-0 pt-0.5">
                <h3
                  className="kc-faq-question block m-0 kc-type-h3 break-words text-[15px] leading-6 sm:text-[17px] sm:leading-[26px]"
                  style={{
                    color: isOpen ? KC_COLORS.teal : KC_COLORS.primaryNavy,
                  }}
                >
                  {question}
                </h3>
              </span>

              <span className="kc-faq-chevron" aria-hidden="true">
                <ExpandMoreRoundedIcon sx={{ fontSize: 22 }} />
              </span>
            </button>

            <div
              id={panelId}
              role="region"
              aria-labelledby={buttonId}
              className="kc-faq-panel"
              style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}
            >
              <div className="kc-faq-panel-inner">
                <div className="kc-faq-answer-wrap">
                  <p className="kc-faq-answer kc-type-body m-0">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
